
import { Vue, Component } from 'vue-property-decorator'
import Delivery from '@/types/delivery'
import moment from 'moment'
import 'moment/locale/nl'
moment.locale('nl')

@Component({
  components: {}
})

export default class DeliveryShowGeneralChecksCard extends Vue {
  settings = {
    routeNames: { list: 'deliveries', show: 'deliveryShow', edit: 'deliveryEdit' },
    routeParamKey: 'deliveryId',
    functionNames: { setCurrent: 'setCurrentDelivery', save: 'saveDelivery' },
    getterNames: { current: 'currentDelivery', loading: 'loadingDelivery', errors: 'deliveryErrors' }
  }

  get currentItem () : Delivery {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
